export const USER_AI_SOLUTION = {id:"user-ai", title:"Пользовательский AI", description:"Поиск идей для поездки и создание маршрутов по запросам пользователей сайта."};
export const USER_AI_TABS = [["overview","Решение"],["agents","Агенты"],["runs","Запуски"],["results","Результаты"],["metrics","Метрики"],["models","Список моделей"],["recovery","Сверка"]];
export const USER_AI_AGENTS = [
 {stage:"query_parse",title:"Разбор запроса",description:"Определяет географию и пожелания, если их не удалось распознать по справочнику.",deadline:3000},
 {stage:"idea_suggest",title:"Дополнительные идеи",description:"Дополняет каталожную выдачу идеями для поездки, когда готовых вариантов недостаточно.",deadline:120000},
 {stage:"route_expand",title:"Создание маршрута",description:"Превращает выбранную идею в маршрут и возвращает ссылку на него.",deadline:300000},
];
// Readiness reasons are server-owned codes. Unknown values never become UI text.
export function userAIReadinessProblem(code) {
 const unavailable="Попросите администратора проверить настройки и совместимость исполнения пользовательского AI.";
 if(typeof code!=="string")return unavailable;
 const global={build_not_published:"Настройки пользовательского AI ещё не опубликованы.",solution_disabled:"Решение выключено для новых запусков.",harness_execution_disabled:"Исполнение Harness не включено в выбранном окружении.",run_admission_disabled:"Создание запусков Harness не включено в выбранном окружении."};
 if(Object.hasOwn(global,code))return global[code];
 const [owner,reason,...rest]=code.split(":");
 if(rest.length)return unavailable;
 const stage=USER_AI_AGENTS.find(agent=>agent.stage===owner);
 if(stage){
  const causes={disabled:"этап отключён в опубликованных настройках.",invalid_profile:"опубликованные настройки этапа некорректны.",deployment_not_ready:"опубликованный исполнитель этапа не готов.",provider_not_configured:"подключение провайдера модели не настроено.",hard_budget_unavailable:"не подтверждены тариф и предельный расход выбранных моделей."};
  return Object.hasOwn(causes,reason)?`${stage.title}: ${causes[reason]}`:unavailable;
 }
 const worker={"user-parse":"разбора запроса","user-ai":"генерации идей и маршрутов"};
 if(Object.hasOwn(worker,owner)&&reason==="worker_not_ready")return `Нет готового исполнителя ${worker[owner]} с совместимой версией Harness.`;
 return unavailable;
}
export function userAIView(value, legacy=false) {
 if(legacy && value==="models") return "settings";
 if(value==="requests") return "runs";
 if(value==="settings") return "settings";
 return USER_AI_TABS.some(([id])=>id===value)?value:legacy?"runs":"overview";
}
export function userAISettingsHash(site="ru",filters={}) {
 const p=new URLSearchParams(filters);
 p.set("site",site==="app"?"app":"ru");p.set("tab","user-ai-settings");p.set("solution","user-ai");
 for(const [key,value] of [...p])if(!value)p.delete(key);
 return "#/settings/triproutes-solutions?"+p;
}
export function userAISolutionHash(site="ru",view="overview",filters={}) {
 if(userAIView(view)==="settings") return userAISettingsHash(site,filters);
 const p=new URLSearchParams(filters);p.set("site",site==="app"?"app":"ru");p.set("tab",userAIView(view));
 for(const [key,value] of [...p])if(!value)p.delete(key);
 return "#/triproutes/solutions/user-ai?"+p;
}
export function userAIRequestParams(filters={}, {site="ru",view="runs",asOf=new Date().toISOString(),cursor=""}={}) {
 const to=filters.to?new Date(filters.to).toISOString():asOf;
 const from=filters.from?new Date(filters.from).toISOString():new Date(new Date(to).getTime()-Number(filters.days||1)*86400000).toISOString();
 const p=new URLSearchParams({...filters,site:site==="app"?"app":"ru",asOf,to,from,limit:"50"});
 p.delete("days");p.delete("tab");p.delete("cursor");
 if(view==="results")p.set("state","completed");
 for(const [key,value]of [...p])if(!value)p.delete(key);
 if(cursor)p.set("cursor",cursor);
 return p;
}
export function userAIRunHash(runId,site,view="runs") {
 return "#/runs/"+encodeURIComponent(runId)+"?"+new URLSearchParams({from:"triproutes",solution:"user-ai",site:site==="app"?"app":"ru",list:view==="results"?"results":"runs"});
}
